import { gql } from '@apollo/client';
import { REPORT } from '../fragments';

export const ALL_REPORTS = gql`
  query AllReports($input: ReportFiltersInput!) {
    reports: getReports(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...report
          createdBy {
            id
            firstName
          }
          funder {
            id
            name
          }
          interventions {
            id
            name
          }
          programmes {
            id
            name
          }
          serviceProvider {
            id
            name
          }
        }
      }
    }
  }
  ${REPORT}
`;
